module.exports = __webpack_public_path__ + "media/es-pc-banner-video.398b813d.mp4";